
/**
 * @export
 * @enum {string}
 */
export enum UserType {
    T_LC = 'T_LC',
    T_MB = 'T_MB',
    T_NA = 'T_NA',
    T_CRM = 'T_CRM',
    T_CA = 'T_CA',
    T_UNSUPPORTED = 'T_UNSUPPORTED'
}